import { useCallback, useMemo } from 'react';
import useAuth from './useAuth';

const useHasAccess = (roles) => {
  const { user } = useAuth();

  return useMemo(() => {
    const userRole = user?.role ? [user?.role] : [];
    if (!roles) {
      return false;
    }

    const isAccess = roles.filter((ele) => userRole.some((item) => item === ele));
    return !!isAccess.length;
  }, [roles, user?.role]);
};
export default useHasAccess;
